import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { Suspense, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import NavBar from './NavBar';
import TopBar from './TopBar';
import PWAPrompt from 'react-ios-pwa-prompt';



const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    paddingTop: 0,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0
    },
  }
}));

function Dashboard({ route }) {
  const classes = useStyles();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  const meta = document.createElement('meta');
  meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  meta.setAttribute('name', 'viewport');
  document.head.appendChild(meta);

  return (
    <>
      <TopBar onOpenNavBarMobile={() => setOpenNavBarMobile(true)} />
      <NavBar onMobileClose={() => setOpenNavBarMobile(false)} openMobile={openNavBarMobile}/>
      <div className={classes.container}>
        <div className={classes.content}>
          <PWAPrompt
            promptOnVisit={1}
            timesToShow={3}
            copyTitle={'Ana Ekrana Ekle'}
            copyBody={'Mobil cihazınızın tarayıcısı üzerinden erişebileceğiniz Artemis uygulaması kolayca indirilebilir ve cihazınızda yer kaplamaz.'}
            copyShareButtonLabel={"1) Alt tarafta bulunan 'Paylaş' ikonuna dokunun"}
            copyAddHomeButtonLabel={"2) Açılan menüde bulunan 'Ana Ekrana Ekle'ye tıklayın"}
            copyClosePrompt={'Kapat'}
            permanentlyHideOnDismiss={false}
          />
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
    </div >
    </>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
